<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>スライド調整単価検索</h1>
<!-- Select what to search -->
<mat-accordion class="expantion-style">
    <mat-expansion-panel class="sg-search-condition-expansion" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <form [formGroup]="slideTankaConditionForm">
                <app-sgkc031d-slide-tanka-search-condition [sgkc027aResponse]="sgkc027aResponse"
                    [codeConversionMstMap]="codeConversionMstMap" [mode]="displayMode"
                    (onClickSearchEvent)="onClickSearch()"
                    (onClickClearEvent)="onClickClear()"></app-sgkc031d-slide-tanka-search-condition>
            </form>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<div *ngIf="showResult && searchResult.length > 0">
    <mat-card class="cur-card">
        <app-sgkc031d-slide-tanka-search-result id="resultComponent" [slideTankatable]="searchResult"
            [mode]="displayMode" (onSelectedEvent)="onSelected($event)" (onDbClickRowEvent)=" onDbClickRow($event)"
            (onClickAddEvent)="onClickAdd()" (onClickSlideTankaOutputEvent)="onClickSlideTankaOutput()"
            (onClickAdjustTankaOutputEvent)="onClickAdjustTankaOutput()"></app-sgkc031d-slide-tanka-search-result>
    </mat-card>
</div>